import React, { Component } from 'react';

import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane, Button, Label, Input
} from "reactstrap";

import AGenerateModel from 'components/generic/AGenerateModel';

import * as commonFunc from 'scripts/common';

import { withRouter } from 'components/withRouter';

class ManageParameters extends Component {
    static displayName = ManageParameters.name;

    static refreshCb;
    static modalRoot;

    constructor(props) {
        super(props);

        this.paramGen = React.createRef(null);

        this.state = { paramModels: null, activeTab: "1", title: "PARAMÈTRES" };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {
            
            //commonFunc.getMethod("../api/site/GetSiteModels", { id: -1, categ: "PARAMS" }).then((responseModels) => {
            //commonFunc.getMethod("../api/site/GetSiteModelsList", { id: -1, categ: "PARAMS" }).then((responseModels) => {
            commonFunc.getMethod("../api/data/GetAllModels", { filter: "site", categ: "PARAMS", useParentSite: true, excludeMode: 1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    var paramModels = null;
                    //dataModels.result?.forEach((model) => {//dataModels.result.models
                    dataModels.result?.map(keyItem => keyItem.tag).forEach((model) => {//dataModels.result.models
                        if (!paramModels) paramModels = {};
                        paramModels[model.extID] = JSON.parse(model.value);
                    });
                    context.setState({ paramModels: paramModels });

                    //Chargement via url
                    var defParamLoadId = 0;
                    //var defParamActionId = 0;
                    if (context.props.searchParams) {
                        defParamLoadId = parseInt(context.props.searchParams.get("paramId")) || 0;
                        //defParamActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                    }
                    if (defParamLoadId > 0) {
                        //var defParamStatusId = parseInt(context.props.searchParams.get("statusId")) || 1100;

                        //TODO : onglet par défaut etc...
                    } else {
                        //TODO : onglet par défaut etc...

                        /*if (defParamActionId == 1) {
                            $(".action-addReport:visible").click();
                        }*/
                    }

                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de chargement des modèles paramètrages :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
    }

    componentWillUnmount() {
        //console.debug("unmount");
    }

    render() {
        //console.debug("render again");

        var curUser = this.props.getUser();
        var isSupport = curUser?.userLogin?.startsWith("support") && curUser.userLogin.endsWith("@softena.com");

        return (
            <div className="tableDetails">
                {this.state.paramModels ? <div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills>
                                {this.props.checkRights("PARAMS", "R") ? <NavItem><NavLink className={`${this.state.activeTab === '1' ? "active" : ""}`} onClick={() => { this.switchTab("1") }}>Paramètres Généraux</NavLink></NavItem> : ""}
                                {isSupport && this.props.checkRights("SERVICE", "U") ? <NavItem><NavLink className={`${this.state.activeTab === '2' ? "active" : ""}`} onClick={() => { this.switchTab("2") }}>Services</NavLink></NavItem> : ""}
                                {isSupport && this.props.checkRights("SITE", "U") ? <NavItem><NavLink className={`${this.state.activeTab === '3' ? "active" : ""}`} onClick={() => { this.switchTab("3") }}>Profils</NavLink></NavItem> : ""}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {this.props.checkRights("PARAMS", "R") ? <TabPane tabId="1">
                            {this.state.activeTab === '1' ? <AGenerateModel ref={this.paramGen} noButtons modelsList={this.state.paramModels} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} configModel={this.state.paramModels ? this.state.paramModels["PARAMS"] : {}} /> : ""}
                        </TabPane> : ""}
                        {this.props.checkRights("SERVICE", "U") ? <TabPane tabId="2">
                            {this.state.activeTab === '2' ? <AGenerateModel ref={this.paramGen} noButtons modelsList={this.state.paramModels} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} configModel={this.state.paramModels ? this.state.paramModels["SERVICES"] : {}} /> : ""}
                        </TabPane> : ""}
                        {isSupport && this.props.checkRights("SITE", "U") ? <TabPane tabId="3">
                            {this.state.activeTab === '3' ? <ProfilManager context={this} /> : ""}
                        </TabPane> : ""}
                    </TabContent>
                </div> : <p><em>Chargement...</em></p>}
            </div>
        );
    }

    switchTab(numTab, entity) {
        this.setState({ activeTab: numTab })
    }
}


/* SERVICES
<Col sm="12" md="6" xl="3" className="p-xl-0">
                        <h6>Secteur d'activité</h6>
                        <Select
                            name="activitySelection"
                            defaultValue={currActivity}
                            options={activities}
                            className={`basic-multi-select mb-3 ${!currActivityInvalid ? "" : "is-invalid"}`}
                            classNamePrefix="select"
                            placeholder="Veuillez sélectionner un secteur d'activité"
                            onChange={(value) => { updateActivity(value); }}
                        />

                        <h6>Sélection des services/modèles d'Intervention</h6>

                        {(groupedServices && Object.keys(groupedServices).length) ? Object.keys(groupedServices).map((parentSvcKey, index) => {
                            var childServices = groupedServices[parentSvcKey];
                            var parentSvc = childServices[0].parent;

                            return <div key={"parentSvc-" + parentSvcKey} className="selectmodel-parentsvc">
                                {parentSvc ? <Label className="fw-bold mt-2 selectmodel-parentlabel">{parentSvc.name}</Label> : ""}
                                {childServices.map((service, index) => {
                                    var modelsFiltered = service.templates && service.templates.length > 0 ? models.filter((model) => {
                                        return service.templates.filter((template) => {
                                            if (template.extID === model.extID) model.template = template;
                                            return template.extID === model.extID;
                                        }).length > 0;
                                    }) : [];

                                    var htmlModels = modelsFiltered.filter(model => model.isHtml).map((model, indexModel) => { return { value: model.idModel, label: model.title } });
                                    var jsonModels = modelsFiltered.filter(model => !model.isHtml).map((model, indexModel) => { return { value: model.idModel, label: model.title } });

                                    var checked = service.isActive;

                                    return <div key={"svc" + service.idService}>

                                        <div className={`form-check form-check-inline fcheck-sm me-2`}>
                                            <Label check for={"modalSelection-" + index} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                                                <div className={`d-inline-block`}>
                                                    <Input type="checkbox" id={"modalSelection-" + index} checked={checked} onChange={(e) => { updateServiceChecked(service.idService, e.target.checked); }} />
                                                    <span className={`form-check-sign`} />
                                                </div>
                                            </Label>
                                        </div>
                                        <Input type="text" className={`w-auto d-inline-block ${!commonFunc.isBlank(service.name) ? "" : "is-invalid"}`} bsSize={"sm"} autoComplete="off" aria-autocomplete="none" defaultValue={service.name} onChange={(event) => { updateServiceName(service.idService, event.target.value); }} />
                                        <Input type="color" className="d-inline-block" autoComplete="off" aria-autocomplete="none" defaultValue={service.startColor} onChange={(event) => { updateServiceColor(service.idService, event.target.value); }} style={{ width: "50px" }} />

                                        {(htmlModels.length || jsonModels.length) ? <div className="w-100">
                                            {
<>
    {htmlModels.length ? <div className="selectmodel-service"><Label>Rapport</Label><Select
        name="modelHtmlSelection"
        defaultValue={htmlModels[0]}
        options={htmlModels}
        className={`basic-multi-select`}
        classNamePrefix="select"
        onChange={(value) => { updateModel(value); }}
    /><Button className="btn-icon" size="sm" color="primary" onClick={() => { showModelPreview(null, modelsFiltered.filter(model => model.isHtml)); }}><i className="fa fa-eye"></i></Button></div> : ""}
    {jsonModels.length ? <div className="selectmodel-service"><Label>Appli.</Label><Select
        name="modelJsonSelection"
        defaultValue={jsonModels[0]}
        options={jsonModels}
        className={`basic-multi-select`}
        classNamePrefix="select"
        onChange={(value) => { updateModel(value); }}
    /><Button className="btn-icon" size="sm" color="primary" onClick={() => { showModelPreview(null, modelsFiltered.filter(model => !model.isHtml)); }}><i className="fa fa-eye"></i></Button></div> : ""}
</>
                                            }
                                        </div > : ""}
                                    </div >;
                                })}
                            </div >
                        }) : "Aucun services paramètrable"}
                    </Col >

*/


const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageParameters));


function ProfilManager({ context }) {

    const [roles, setRoles] = React.useState(null);
    const [profiles, setProfiles] = React.useState([]);

    const [selectedTab, setSelectedTab] = React.useState(1);
    const [selectedProfile, setSelectedProfile] = React.useState(null);


    React.useEffect(() => {
        getRoles();

        refreshProfiles();
    }, []);

    function getSite() {
        var appSite = context.props.getSite();

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        return commonFunc.getMethod("../api/site/GetSite", { id: appSite.idSite }).then((response) => {
            Swal.close();
            var data = response.data;
            if (data.isSuccess) {
                console.log(data.result);

                //setSite(data.result);
                return new Promise((resolve, reject) => {
                    resolve(response);
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("site.failLoadSite") + " :<br>" + data.errorMessage
                });
            }
        });
    }

    function refreshProfiles(currentProfile) {
        //var appSite = context.props.getSite();

        getSite().then((response) => {
            if (response.data.isSuccess) {
                var filteredExtraProfile = response.data.result?.extras?.filter(extra => extra.format === "PROFILE");
                var filteredExtraClaims = response.data.result?.extras?.filter(extra => extra.format === "PROFILECLAIMS");

                if (filteredExtraProfile?.length) {
                    var loadedSelProfile;
                    var loadedProfiles = filteredExtraProfile.map(extra => {
                        var parsedExtra = JSON.parse(extra.value);

                        if (parsedExtra.description === "4") return null;

                        if (currentProfile && extra.name === currentProfile.name) {
                            parsedExtra.selected = true;
                            loadedSelProfile = parsedExtra;
                        }

                        if (filteredExtraClaims?.length) {
                            var profileClaims = filteredExtraClaims.filter(extraClaims => extraClaims.tag === extra.name);
                            if (profileClaims.length) {
                                var parsedExtraClaims = JSON.parse(profileClaims[0].value);
                                parsedExtra.roleClaims = parsedExtraClaims.flags;
                            }
                        }

                        return parsedExtra;
                    }).filter(profile => profile !== null);


                    setProfiles(loadedProfiles);
                    setSelectedProfile(loadedSelProfile ? loadedSelProfile : loadedProfiles[0]);
                }
            }
        });
    }

    function getRoles() {
        commonFunc.getMethod("../api/GetRoles", null).then((response) => {
            var data = response.data;
            if (data.isSuccess) {
                setRoles(data.result);
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: data.errorMessage
                });
            }
        });
    }

    function addProfile(profile) {//TODO : Update ?? (conséquence changement role source + changement name)
        //var appSite = context.props.getSite();

        getSite().then((response) => {
            if (response.data.isSuccess) {
                Swal.fire({
                    title: context.props.i18nManager.t("gal_saving"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                var site = response.data.result;

                var nameNode = document.getElementById("profileName");
                var sourceNode = document.getElementById("profileRoleSource");

                commonFunc.getMethod("../api/GetRoleClaims", { name: sourceNode.value }).then((responseClaims) => {
                    var data = responseClaims.data;

                    var claims = [];
                    if (data.isSuccess) {
                        claims = data.result;
                        /*var filteredRole = roles.filter(role => role.name === sourceNode.value);
                        if (filteredRole.length) {
                            claims = filteredRole[0].roleClaims || [];
                        }*/
                    }
                    else {
                        /*Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: data.errorMessage
                        });*/
                    }

                    var profilRoleId = -1;
                    var profilRoleDesc = "";
                    var filteredRole = roles?.filter(role => role.name === sourceNode.value);
                    if (filteredRole.length) {
                        profilRoleId = filteredRole[0].id;
                        profilRoleDesc = filteredRole[0].description;
                    }

                    var normalizedName = nameNode.value;
                    normalizedName = normalizedName.trim().toLowerCase();
                    var splitSpaces = normalizedName.split(" ");
                    normalizedName = splitSpaces.map((part, index) => commonFunc.capitalize(part)).join();
                    normalizedName = normalizedName
                        .replace(/έ/g, 'ε')
                        .replace(/[ύϋΰ]/g, 'υ')
                        .replace(/ώ/g, 'ω')
                        .replace(/ά/g, 'α')
                        .replace(/[ίϊΐ]/g, 'ι')
                        .replace(/ή/g, 'η')
                        .replace(/\n/g, ' ')
                        .replace(/á/g, 'a')
                        .replace(/â/g, 'a')
                        .replace(/ã/g, 'a')
                        .replace(/é/g, 'e')
                        .replace(/ê/g, 'e')
                        .replace(/ë/g, 'e')
                        .replace(/è/g, 'e')
                        .replace(/í/g, 'i')
                        .replace(/î/g, 'i')
                        .replace(/ï/g, 'i')
                        .replace(/ì/g, 'i')
                        .replace(/ó/g, 'o')
                        .replace(/ô/g, 'o')
                        .replace(/õ/g, 'o')
                        .replace(/ό/g, 'ο')
                        .replace(/ú/g, 'u')
                        .replace(/ü/g, 'u')
                        .replace(/ç/g, 'c');

                    var newProfile = { name: "PRFL_" + normalizedName, id: profilRoleId, normalizedName: sourceNode.value, description: profilRoleDesc };//, roleClaims: claims
                    var extra = { idExtra: 0, name: newProfile.name, value: JSON.stringify(newProfile), extraSiteID: site.idSite, siteID: site.idSite, format: "PROFILE", dataType: "PRIMARYSID_" + profilRoleDesc, objType: "ACCOUNTTYPE_" + (profilRoleDesc === "1" ? 2 : 1) };
                    var extraClaim = { idExtra: 0, name: "CLAIMS_" + normalizedName, value: JSON.stringify({ "userID": 0, "siteID": 0, "flags": claims }), extraSiteID: site.idSite, siteID: site.idSite, format: "PROFILECLAIMS", tag: extra.name };

                    if ((!site.extras?.length || !site.extras.filter(extra => extra.name === newProfile.name).length) && filteredRole.length) {
                        if (!site.extras) site.extras = [];
                        site.extras.push(extra);
                        site.extras.push(extraClaim);

                        site.parent = null;
                        commonFunc.postMethod("../api/site/UpdateSite", site).then((response) => {

                            Swal.close();
                            if (response.data && response.data.isSuccess) {
                                Swal.fire({
                                    icon: "success",
                                    title: context.props.i18nManager.t("gal_success"),
                                    html: "Création du profil effectuée",
                                    didOpen: () => { Swal.hideLoading() },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                }).then((result) => {
                                    refreshProfiles(newProfile);
                                });
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_fail") + "<br/>" + response.data.errorMessage
                                });
                            }
                        });
                    }
                    else {
                        Swal.fire({
                            icon: "warning",
                            title: "Veuillez changer de nom de profil, nom déjà utilisé",
                            html: data.errorMessage
                        });
                    }
                });
                
            }
        });
    }

    var modelAccesTab = context.paramModels ? context.paramModels["ACCESSTAB"] : null;

    return <Row className="employee-history">
        <Col lg="12">
            <Card className="widget dash">
                <CardHeader>
                    <CardTitle tag="h6">{"Profils"}</CardTitle>
                    <div className="widget-tools collapse-tool">
                        <i className="fa fa-users fa-4x"></i>
                    </div>
                    <div className='borderTheme'></div>
                </CardHeader>
                <CardBody>
                    {!(selectedProfile && !selectedProfile.name) ? <div>
                        <Button className="btn-rotate px-2 btn-simple mt-0" color="dark" size="sm" onClick={() => refreshProfiles()}>
                            <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                        </Button>
                        <div className="d-flex align-items-center">
                            <div style={{ flex: "auto" }}>
                                <Label className="profil-selector-label m-0" for="profilList">{"Profil"}</Label>
                                <Input id={"profilList"} bsSize="sm" className="profil-selector" type="select" value={selectedProfile?.name} onChange={(e) => {
                                    var value = e.target.value;
                                    var changeProfile = profiles.filter(profile => profile.name === value);
                                    if (changeProfile?.length) setSelectedProfile(changeProfile[0]);
                                }}>
                                    {profiles?.map(profile => <option selected={profile.selected} value={profile.name}>{profile.name.replace("PRFL_", "")}</option>)}
                                </Input>
                            </div>
                            <Button className="btn-icon m-0 ms-2" color="success" onClick={() => { setSelectedProfile({}) }}><i className="fa fa-plus"></i></Button>
                            <div className="hr-line-solid"></div>
                        </div>
                        <div className="hr-line-solid"></div>
                    </div> : ""}
                    {selectedProfile ? <Row>
                        <Col xs="6" className="my-2 pe-2">
                            <Label className="role-name-label m-0" for="profileName">{"Nom"}</Label>
                            <Input key={"name:" + selectedProfile.name} id="profileName" bsSize="sm" type="text" defaultValue={selectedProfile.name} disabled={selectedProfile?.name ? true : false} />
                        </Col>
                        {roles?.length ? <Col xs="6" className="my-2 w-50 ps-2">
                            <Label className="role-updater-label m-0" for="profileRoleSource">{"Origine"}</Label>
                            <Input key={"source:" + selectedProfile.name} id={"profileRoleSource"} bsSize="sm" className="role-updater" type="select" defaultValue={selectedProfile.normalizedName} disabled={selectedProfile?.name ? true : false}>
                                {roles.filter(role => (!modelAccesTab?.roles || modelAccesTab?.roles.indexOf(role.name) <= 0)).map(role => {
                                    return <option value={role.name}>{role.normalizedName}</option>
                                })}
                            </Input>
                        </Col> : ""}
                        {selectedProfile?.name ? <div>
                            <div>
                                <Button onClick={() => { setSelectedTab(1) }}>Rights</Button>
                                <Button onClick={() => { setSelectedTab(2) }}>Menu</Button>
                            </div>
                            <div>
                                {selectedTab === 1 ? <ManageRights context={context} profile={selectedProfile} groupsConfig={modelAccesTab?.groups} refreshProfiles={refreshProfiles} getSite={getSite} shouldRender={true} />
                                    : <ManageMenu context={context} profile={selectedProfile} refreshProfiles={refreshProfiles} shouldRender={true} />}
                            </div>
                        </div> : <div><Button color="primary" onClick={() => { addProfile(selectedProfile) }}>Sauvegarder</Button><Button color="danger" onClick={() => { setSelectedProfile(profiles?.length ? profiles[0] : null) }}>Annuler</Button></div>}
                    </Row> : ""}
                </CardBody>
            </Card>
        </Col>
    </Row>;
}

function ManageRights(props) {
    var { context, profile, groupsConfig, refreshProfiles, getSite, shouldRender } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

    const [roleRightsItems, setRoleRightsItems] = React.useState(profile.roleClaims ? JSON.parse(JSON.stringify(profile.roleClaims)) : []);
    const [userRightsItems, setUserRightsItems] = React.useState(profile.roleClaims ? JSON.parse(JSON.stringify(profile.roleClaims)) : []);

    React.useEffect(() => {
        setUserRightsItems(profile.roleClaims);
        setRoleRightsItems(profile.roleClaims);
    }, [profile]);

    function manageRights(item, right, state) {
        var newRights = userRightsItems;
        if (state) {
            var rightsTab = ["C", "R", "U", "D", "L", "S", "A"];

            var targetT = newRights.filter(listItem => item.entity === listItem.entity);
            if (targetT.length) {
                var concatRights = "";
                rightsTab.forEach((tabItem, index) => {
                    if (targetT[0].value.indexOf(tabItem) >= 0 || tabItem === right) concatRights += tabItem;
                });
                targetT[0].value = concatRights;

                setUserRightsItems(newRights);
            }
            else {
                newRights.push({ "value": right, "active": true, "extId": 0, "entity": item.entity });
                setUserRightsItems(newRights);
            }
        }
        else {
            var target = newRights.filter(listItem => item.entity === listItem.entity);
            if (target.length) {
                target[0].value = target[0].value.replace(right, "");

                setUserRightsItems(newRights);
            }
            else {
                newRights.push({ "value": "", "active": true, "extId": 0, "entity": item.entity });
                setUserRightsItems(newRights);
            }
        }
    }

    function saveRights() {
        var newRightsParams = roleRightsItems;

        //var appSite = context.props.getSite();

        getSite().then((response) => {
            if (response.data.isSuccess) {
                Swal.fire({
                    title: context.props.i18nManager.t("gal_saving"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                var site = response.data.result;

                var extraClaim = { idExtra: 0, name: "CLAIMS_" + profile.name.replace("PRFL_", ""), value: JSON.stringify({ "userID": 0, "siteID": 0, "flags": newRightsParams }), extraSiteID: site.idSite, siteID: site.idSite, format: "PROFILECLAIMS", tag: profile.name };

                if (!site.extras) site.extras = [];
                site.extras.forEach(srcExtra => {
                    if (extraClaim.name === srcExtra.name) srcExtra.value = extraClaim.value;
                });

                site.parent = null;
                //console.debug(site);
                commonFunc.postMethod("../api/site/UpdateSite", site).then((response) => {

                    Swal.close();
                    if (response.data && response.data.isSuccess) {
                        Swal.fire({
                            icon: "success",
                            title: context.props.i18nManager.t("gal_success"),
                            html: "Mise à jour effectuée",
                            didOpen: () => { Swal.hideLoading() },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                        }).then((result) => {
                            refreshProfiles(profile);
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_fail"),
                            html: context.props.i18nManager.t("gal_fail") + "<br/>" + response.data.errorMessage
                        });
                    }
                });
            }
        });
    }

    //var displayItems = roleMenuItems.filter(srcItem => (!srcItem.path || srcItem.path.indexOf("ManageSubscription") < 0) && !srcItem.redirect);
    var displayItems = roleRightsItems;

    if (groupsConfig && displayItems?.length) {
        groupsConfig.forEach(group => {
            var groupRight = { "value": "CRUDLS", "active": true, "extId": 0, "entity": "G-" + group, isGroup: true };
            var rightsFiltered = roleRightsItems.filter(right => (right.entity === group || right.entity.startsWith(group + "_")));
            groupRight.childs = rightsFiltered;

            displayItems = displayItems.filter(right => !(right.entity === group || right.entity.startsWith(group + "_")));
            displayItems.unshift(groupRight);
        });
        displayItems.sort((a, b) => a.entity.localeCompare(b.entity));
    }

    return (shouldRender && displayItems?.length) ? <div className="manage-rights">
        <Button className="btn-rotate px-2 btn-simple mt-0" color="dark" size="sm" onClick={() => refreshProfiles(profile)}>
            <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh") + "/" + context.props.i18nManager.t("gal_cancel")}
        </Button>
        <Button className="btn-magnify px-2 mt-0" color="primary" size="sm" onClick={() => saveRights()}>
            <i className="fa fa-save"></i>{context.props.i18nManager.t("gal_save")}
        </Button>
        <div className="mr-list">
            {displayItems?.map((srcRight, index) => <RightItem {...props} key={"right" + index + srcRight.entity} nodeID={index + srcRight.entity} data={srcRight}
                manageRights={manageRights} roleRightsItems={roleRightsItems} userRightsItems={userRightsItems} />)}
        </div>
    </div> : <p className="text-center align-content-center"><i className="fa fa-circle-notch fa-spin fa-2x"></i></p>;
}

function RightItem(props) {
    var { data, context, nodeID, manageRights, roleRightsItems, userRightsItems } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
    var customItemT = (label, args) => { return (label && context.props.i18nManager.t("accessitem." + label.toLowerCase()) !== "accessitem." + label.toLowerCase()) ? context.props.i18nManager.t("accessitem." + label.toLowerCase()) : label };

    function manageChecked() {
        if (data.isGroup) {
            var groupChecked = { "C": true, "R": true, "U": true, "D": true, "L": true, "S": true, "A": true };
            data.childs.forEach(child => {
                var filteredUserRights = userRightsItems?.filter(userRight => userRight.entity === child.entity);
                if (filteredUserRights?.length) {
                    groupChecked["C"] &= filteredUserRights[0].value.indexOf("C") >= 0;
                    groupChecked["R"] &= filteredUserRights[0].value.indexOf("R") >= 0;
                    groupChecked["U"] &= filteredUserRights[0].value.indexOf("U") >= 0;
                    groupChecked["D"] &= filteredUserRights[0].value.indexOf("D") >= 0;
                    groupChecked["L"] &= filteredUserRights[0].value.indexOf("L") >= 0;
                    groupChecked["S"] &= filteredUserRights[0].value.indexOf("S") >= 0;
                    groupChecked["A"] &= filteredUserRights[0].value.indexOf("A") >= 0;
                }
            });
            return groupChecked;
        }
        else {
            var filteredUserRights = userRightsItems?.filter(userRight => userRight.entity === data.entity);
            if (filteredUserRights?.length) {
                return {
                    "C": filteredUserRights[0].value.indexOf("C") >= 0, "R": filteredUserRights[0].value.indexOf("R") >= 0, "U": filteredUserRights[0].value.indexOf("U") >= 0,
                    "D": filteredUserRights[0].value.indexOf("D") >= 0, "L": filteredUserRights[0].value.indexOf("L") >= 0, "S": filteredUserRights[0].value.indexOf("S") >= 0, "A": filteredUserRights[0].value.indexOf("A") >= 0
                };
            }
        }
        return { "C": false, "R": false, "U": false, "D": false, "L": false, "S": false, "A": false };
    }


    const [checked, setChecked] = React.useState(manageChecked);
    const [collapsed, setCollapsed] = React.useState(true);//TEMP

    React.useEffect(() => {
        setChecked(manageChecked);
    }, [userRightsItems]);

    var rightsTab = ["C", "R", "U", "D", "L", "S", "A"];

    function manageLabel(right) {
        return altT("i18n:accessitem." + right.entity.toLowerCase());
    }

    function onChange(e, tabRight) {
        var newChecked = checked;
        newChecked[tabRight] = !checked[tabRight];
        setChecked(Object.assign({}, newChecked));

        if (data.isGroup) {
            data.childs.forEach((child) => {
                //manageRights(child, tabRight, newChecked[tabRight]);
                child.cTriggerChecked(tabRight, newChecked[tabRight]);
            });
        }
        else {
            //TODO : change data direct ?!
            manageRights(data, tabRight, newChecked[tabRight]);
        }
    }

    data.cTriggerChecked = (right, state) => {
        //Prevent if disabled
        if (/*right !== "R" && right !== "L" &&*/ data.value.indexOf(right) >= 0) {
            var newChecked = checked;
            newChecked[right] = state;
            setChecked(Object.assign({}, newChecked));
            manageRights(data, right, state);
        }
    };

    return <div className="ms-2">
        <div className={`items-container d-flex align-items-center px-1 ${data.isGroup ? "group-container" : ""}`}>
            <span className={`p-1 cursor-pointer ${data.childs?.length ? "" : "invisible"}`} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setCollapsed(!collapsed);
            }}>{(collapsed ? <i className="fa fa-angle-right me-1 mt-1 text-muted" style={{ width: "10px" }}></i> : <i className="fa fa-angle-down me-1 mt-1" style={{ width: "10px" }}></i>)}</span>
            <span title={data.isGroup ? "" : data.entity} style={{ flex: "auto" }}>{customItemT(data.entity)}</span>
            <div className="float-sm-end">
                {rightsTab.map(tabRight => {
                    //var authorizedItems = roleRightsItems.filter(roleRight => data.entity === roleRight.entity && roleRight.value.indexOf(tabRight) >= 0);
                    var inputSupProps = { /*disabled: "disabled"*/ };
                    if (true) {//(/*tabRight !== "R" && tabRight !== "L" &&*/ (data.isGroup || data.value.indexOf(tabRight) >= 0))
                        delete inputSupProps.disabled;
                        inputSupProps.onChange = (e) => {
                            onChange(e, tabRight);
                        };
                    }

                    return (<div key={"right" + nodeID + tabRight} className={`form-check form-check-inline fcheck-sm form-group ${inputSupProps.disabled ? "disabled" : ""}`} style={{ minHeight: "0px" }}>
                        <Label check for={"node" + nodeID + tabRight} className={`d-inline-block px-0 w-100`}>
                            <div className={`d-inline-block`} style={{ position: "relative", top: "-12px" }}>
                                <Input type="checkbox" id={"node" + nodeID + tabRight} checked={checked[tabRight]} {...inputSupProps} />
                                <span className={`form-check-sign`} />
                            </div>
                            <div className={`d-inline-block ms-3 px-0`}>
                                <span style={{ flex: "auto" }}>{tabRight}</span>
                            </div>
                        </Label>
                    </div>)
                })}
            </div>

        </div>
        {!collapsed && data.childs?.map((subItem, index) => !subItem.redirect ? <RightItem {...props} key={"subItem" + data.entity.replaceAll(" ", "") + index + subItem.entity.replaceAll(" ", "")} nodeID={data.entity.replaceAll(" ", "") + index + subItem.entity.replaceAll(" ", "")} parentData={data} data={subItem} /> : "")}
    </div>;
}


function ManageMenu(props) {
    var { context, profile, refreshProfiles, shouldRender } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

    const [roleMenuItems, setRoleMenuItems] = React.useState([{ "icon": "fa fa-file-signature", "name": "Module Custom", "path": "/ManageCustom", "layout": "", "redirect": true, "keyComponent": "ManageCustom" }, { "icon": "fa fa-home", "name": "Accueil", "path": "/Home", "index": true, "entity": "DASHBOARD", "layout": "", "rights": "L", "keyComponent": "home" }, { "icon": "fa fa-download", "name": "Contrôles TG", "path": "/ManageCustom?key=ANOMALIE", "entity": "CUSTOM_ANOMALIE", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fa fa-envelope", "name": "Envoi des plannings", "path": "/ManageCustom?key=EMPHOURS", "entity": "CUSTOM_EMPHOURS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads", "entity": "LEAD", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads?pageModels=DIALOGLEAD&categoryGroupKey=PROSPECT", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "DEV Prospect Client", "path": "/ManageClients", "entity": "CLIENT", "layout": "", "rights": "L", "keyComponent": "ManageClients" }, { "icon": "fas fa-hard-drive", "name": "Documents partagés", "path": "/ManageFiles", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageFiles" }, { "icon": "fa fa-clipboard-list", "name": "Enquêtes", "path": "/ManageLeads?pageModels=SURVEY&categoryGroupKey=SURVEY", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fa fa-chart-area", "name": "Gestion Stats", "path": "/ManageCustom?key=STATS", "entity": "CUSTOM_STATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-toolbox", "name": "Boîte à outils", "state": "toolboxCollapse", "views": [{ "mini": "E", "name": "Employés", "path": "/ManageEmployees", "entity": "EMPLOYEE", "layout": "", "rights": "L", "keyComponent": "ManageEmployees" }, { "mini": "A", "name": "Agences", "path": "/ManageSites", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageSites" }, { "mini": "C", "name": "Gestion contenu", "path": "/ManageContent", "entity": "CUSTOM", "layout": "", "rights": "L", "keyComponent": "ManageContent" }, { "mini": "A", "name": "Gérer l'abonnement", "path": "/ManageSubscriptions", "entity": "SUBSCRIPTION", "layout": "", "rights": "L", "keyComponent": "ManageSubscriptions" }, { "mini": "U", "name": "Utilisateurs", "path": "/ManageUsers", "entity": "USER", "layout": "", "rights": "L", "keyComponent": "manageUsers" }, { "mini": "J", "name": "Jobs", "path": "/ManageJobs", "entity": "JOBS", "layout": "", "rights": "L", "keyComponent": "ManageJobs" }, { "mini": "L", "name": "Logs", "path": "/ManageCustom?key=LOGS", "entity": "CUSTOM_LOGS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }], "entity": "TOOLS", "rights": "L", "collapse": true }, { "icon": "fas fa-file-signature", "name": "Etat des lieux", "path": "/ManageReportsItv", "entity": "REPORT", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageReportsItv" }, { "icon": "fas fa-car", "name": "Véhicules", "state": "vehicleCollapse", "views": [{ "mini": "G", "name": "Gestion Véhicules", "path": "/ManageMaterials", "entity": "MATERIAL", "layout": "", "rights": "L", "pathOLD": "/ManageMaterials?categoryGroupKey=VCL", "keyComponent": "ManageMaterials" }, { "mini": "P", "name": "Planning Matériel", "path": "/matPlanning", "entity": "MATERIAL_EVENTS", "layout": "", "rights": "L", "keyComponent": "fcPlanningMat" }, { "mini": "S", "name": "Suivi Véhicules", "path": "/ManageCustom?key=CARSSTATS", "entity": "CUSTOM_CARSSTATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "mini": "E", "name": "Etat des lieux", "path": "/ManageReportsItv?reportId=1&statusId=202", "entity": "REPORT", "layout": "", "rights": "L", "keyComponent": "ManageReportsItv" }, { "mini": "B", "name": "Badgeage Véhicules", "path": "/ManageTG", "entity": "WORKEVENT", "layout": "", "rights": "L", "keyComponent": "ManageTG" }], "entity": "", "rights": "", "collapse": true }, { "icon": "fas fa-computer", "name": "Parc Info.", "path": "/ManageMaterials?categoryGroupKey=INFO&pageModels=INFO", "entity": "MATERIAL", "layout": "", "rights": "L", "keyComponent": "ManageMaterials" }, { "icon": "fas fa-calendar", "name": "Planning", "path": "/planning", "entity": "PLANNING", "layout": "", "rights": "L", "keyComponent": "fcPlanning" }, { "icon": "fas fa-life-ring", "name": "Demandes d'assistance", "path": "/ManageTickets", "entity": "TICKET", "layout": "", "rights": "L", "keyComponent": "ManageTickets" }, { "icon": "fa fa-user", "name": "Pages", "path": "/showContent", "layout": "", "redirect": true, "keyComponent": "showContent" }, { "tag": "RH", "icon": "fa fa-user", "name": "RH", "state": "rhCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true }, { "tag": "TAB", "icon": "fas fa-list", "name": "TAB", "state": "tabCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }, { "tag": "DOC", "icon": "fa fa-book-bookmark", "name": "Documents", "state": "docCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }]);
    const [userMenuItems, setUserMenuItems] = React.useState([{ "icon": "fa fa-file-signature", "name": "Module Custom", "path": "/ManageCustom", "layout": "", "redirect": true, "keyComponent": "ManageCustom" }, { "icon": "fa fa-home", "name": "Accueil", "path": "/Home", "index": true, "entity": "DASHBOARD", "layout": "", "rights": "L", "keyComponent": "home" }, { "icon": "fa fa-download", "name": "Contrôles TG", "path": "/ManageCustom?key=ANOMALIE", "entity": "CUSTOM_ANOMALIE", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads", "entity": "LEAD", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads?pageModels=DIALOGLEAD&categoryGroupKey=PROSPECT", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "DEV Prospect Client", "path": "/ManageClients", "entity": "CLIENT", "layout": "", "rights": "L", "keyComponent": "ManageClients" }, { "icon": "fas fa-hard-drive", "name": "Documents partagés", "path": "/ManageFiles", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageFiles" }, { "icon": "fa fa-clipboard-list", "name": "Enquêtes", "path": "/ManageLeads?pageModels=SURVEY&categoryGroupKey=SURVEY", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fa fa-chart-area", "name": "Gestion Stats", "path": "/ManageCustom?key=STATS", "entity": "CUSTOM_STATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-toolbox", "name": "Boîte à outils", "state": "toolboxCollapse", "views": [{ "mini": "E", "name": "Employés", "path": "/ManageEmployees", "entity": "EMPLOYEE", "layout": "", "rights": "L", "keyComponent": "ManageEmployees" }, { "mini": "A", "name": "Agences", "path": "/ManageSites", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageSites" }, { "mini": "C", "name": "Gestion contenu", "path": "/ManageContent", "entity": "CUSTOM", "layout": "", "rights": "L", "keyComponent": "ManageContent" }, { "mini": "A", "name": "Gérer l'abonnement", "path": "/ManageSubscriptions", "entity": "SUBSCRIPTION", "layout": "", "rights": "L", "keyComponent": "ManageSubscriptions" }, { "mini": "U", "name": "Utilisateurs", "path": "/ManageUsers", "entity": "USER", "layout": "", "rights": "L", "keyComponent": "manageUsers" }, { "mini": "J", "name": "Jobs", "path": "/ManageJobs", "entity": "JOBS", "layout": "", "rights": "L", "keyComponent": "ManageJobs" }, { "mini": "L", "name": "Logs", "path": "/ManageCustom?key=LOGS", "entity": "CUSTOM_LOGS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }], "entity": "TOOLS", "rights": "L", "collapse": true }, { "icon": "fas fa-file-signature", "name": "Etat des lieux", "path": "/ManageReportsItv", "entity": "REPORT", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageReportsItv" }, { "icon": "fas fa-car", "name": "Véhicules", "state": "vehicleCollapse", "views": [{ "mini": "G", "name": "Gestion Véhicules", "path": "/ManageMaterials", "entity": "MATERIAL", "layout": "", "rights": "L", "pathOLD": "/ManageMaterials?categoryGroupKey=VCL", "keyComponent": "ManageMaterials" }, { "mini": "P", "name": "Planning Matériel", "path": "/matPlanning", "entity": "MATERIAL_EVENTS", "layout": "", "rights": "L", "keyComponent": "fcPlanningMat" }, { "mini": "S", "name": "Suivi Véhicules", "path": "/ManageCustom?key=CARSSTATS", "entity": "CUSTOM_CARSSTATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "mini": "E", "name": "Etat des lieux", "path": "/ManageReportsItv?reportId=1&statusId=202", "entity": "REPORT", "layout": "", "rights": "L", "keyComponent": "ManageReportsItv" }, { "mini": "B", "name": "Badgeage Véhicules", "path": "/ManageTG", "entity": "WORKEVENT", "layout": "", "rights": "L", "keyComponent": "ManageTG" }], "entity": "", "rights": "", "collapse": true }, { "icon": "fas fa-computer", "name": "Parc Info.", "path": "/ManageMaterials?categoryGroupKey=INFO&pageModels=INFO", "entity": "MATERIAL", "layout": "", "rights": "L", "keyComponent": "ManageMaterials" }, { "icon": "fas fa-calendar", "name": "Planning", "path": "/planning", "entity": "PLANNING", "layout": "", "rights": "L", "keyComponent": "fcPlanning" }, { "icon": "fas fa-life-ring", "name": "Demandes d'assistance", "path": "/ManageTickets", "entity": "TICKET", "layout": "", "rights": "L", "keyComponent": "ManageTickets" }, { "icon": "fa fa-user", "name": "Pages", "path": "/showContent", "layout": "", "redirect": true, "keyComponent": "showContent" }, { "tag": "RH", "icon": "fa fa-user", "name": "RH", "state": "rhCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true }, { "tag": "TAB", "icon": "fas fa-list", "name": "TAB", "state": "tabCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }, { "tag": "DOC", "icon": "fa fa-book-bookmark", "name": "Documents", "state": "docCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }]);

    const [model, setModel] = React.useState(null);

    React.useEffect(() => {
        setUserMenuItems(profile.roleClaims);
        setRoleMenuItems(profile.roleClaims);
    }, [profile]);

    function manageElements(item, state) {
        var srcItems;
        if (item.parent) {
            var userParentMenu = userMenuItems.filter(parents => parents.state === item.parent);
            if (userParentMenu.length && userParentMenu[0].views) {
                if (state) {
                    userParentMenu[0].views.push({ ...item });
                }
                else {
                    userParentMenu[0].views = userParentMenu[0].views.filter(listItem => !(item.name === listItem.name && item.path === listItem.path));
                }

                srcItems = roleMenuItems.map(listItem => {
                    var returnedItem = listItem;
                    var userParent = userMenuItems.filter(userItem => (returnedItem.name === userItem.name && returnedItem.path === userItem.path));
                    if (listItem.views) {
                        returnedItem = Object.assign({}, returnedItem);
                        if (userParent.length > 0) {
                            returnedItem.views = returnedItem.views.filter(childListItem => {
                                return userParent[0].views.filter(childUserItem => (childListItem.name === childUserItem.name && childListItem.path === childUserItem.path)).length > 0;
                            });
                        }
                    }
                    return userParent.length > 0 ? returnedItem : null;
                }).filter(item => item !== null);
                setUserMenuItems(JSON.parse(JSON.stringify(srcItems)));
            }
        }
        else {
            if (state) {
                userMenuItems.push({ ...item });
                srcItems = roleMenuItems.filter(listItem => {
                    return userMenuItems.filter(userItem => (listItem.name === userItem.name && listItem.path === userItem.path)).length > 0;
                });
            }
            else {
                srcItems = userMenuItems.filter(listItem => !(item.name === listItem.name && item.path === listItem.path));
            }
            setUserMenuItems(JSON.parse(JSON.stringify(srcItems)));
        }
    }

    function saveMenu() {
        Swal.fire({
            title: context.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var newMenuParams = userMenuItems;

        var updatingProfile = { ...profile, menu: newMenuParams };//TODO

        var req = { id: profile.menu.idModel, newMenu: newMenuParams };//TODO
        commonFunc.postMethod("../api/site/UpdateSiteModel", req).then((response) => {// TODO

            Swal.close();
            if (response.data && response.data.isSuccess) {
                Swal.fire({
                    icon: "success",
                    title: context.props.i18nManager.t("gal_success"),
                    html: "Mise à jour effectuée",
                    didOpen: () => { Swal.hideLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    refreshProfiles(updatingProfile);
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_fail") + "<br/>" + response.data.errorMessage
                });
            }
        });
    }

    if (roleMenuItems?.length && userMenuItems?.length) {
        roleMenuItems.forEach(item => {
            var echosItem = userMenuItems.filter(userItem => (item.name === userItem.name && item.path === userItem.path));
            item.isActive = echosItem.length > 0;
        });
    }
    var displayItems = roleMenuItems?.filter(srcItem => (!srcItem.path || srcItem.path.indexOf("ManageSubscription") < 0) && !srcItem.redirect);


    return (shouldRender && displayItems?.length) ? <div className="manage-menu">
        <Button className="btn-rotate px-2 btn-simple mt-0" color="dark" size="sm" onClick={() => refreshProfiles(profile)}>
            <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh") + "/" + context.props.i18nManager.t("gal_cancel")}
        </Button>
        <Button className="btn-magnify px-2 mt-0" color="primary" size="sm" onClick={() => saveMenu()}>
            <i className="fa fa-save"></i>{context.props.i18nManager.t("gal_save")}
        </Button>
        <div className="mm-list">
            {displayItems?.map((item, index) => <MenuItem {...props} key={"item" + index + item.name} nodeID={index + item.name.replaceAll(" ", "")} data={item} isActive={item.isActive} manageElements={manageElements} />)}
        </div>
    </div> : <p className="text-center align-content-center"><i className="fa fa-circle-notch fa-spin fa-2x"></i></p>;
}

function MenuItem(props) {
    var { data, parentData, context, nodeID, manageElements } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
    var customItemT = (label, args) => { return (label && context.props.i18nManager.t("accessitem." + label) !== "accessitem." + label) ? context.props.i18nManager.t("accessitem." + label) : label };

    const [checked, setChecked] = React.useState(props.isActive);
    const [collapsed, setCollapsed] = React.useState(false);//TEMP

    return <div className="ms-2">
        <div className={`items-container d-flex align-items-center px-1`} style={checked ? { backgroundColor: "#AAAAAA66", borderRadius: "5px" } : {}}>
            <span className={`p-1 cursor-pointer ${data.views?.length ? "" : "invisible"}`} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setCollapsed(!collapsed);
            }}>{(collapsed ? <i className="fa fa-angle-right me-1 mt-1 text-muted" style={{ width: "10px" }}></i> : <i className="fa fa-angle-down me-1 mt-1" style={{ width: "10px" }}></i>)}</span>
            <div className={`form-check form-check-inline fcheck-sm form-group float-sm-end m-0 me-3`} style={{ minHeight: "0px" }}>
                <Label check for={"node" + nodeID} className={`d-inline-block px-0 w-100`} style={{ minWidth: "16px" }}>
                    <div className={`d-inline-block`} style={{ position: "relative", top: "-12px" }}>
                        <Input type="checkbox" id={"node" + nodeID} checked={checked} onChange={(e) => {
                            setChecked(!checked);

                            //TODO : change data direct ?!
                            if (data.mini && parentData) data.parent = parentData.state;
                            manageElements(data, !checked);
                        }} />
                        <span className={`form-check-sign`} />
                    </div>
                    <div className={`d-inline-block ms-4 px-0`}>
                        <i className={`${data.icon ? "text-dark " + data.icon : (data.mini ? ("text-secondary fa fa-" + data.mini?.toLowerCase()) : "text-secondary fa fa-square")} me-1`}></i> <span title={data.path} style={{ flex: "auto" }}>{customItemT(data.name)}</span>
                    </div>
                </Label>
            </div>

        </div>
        {data.isActive && !collapsed && data.views?.map((subItem, index) => !subItem.redirect ? <MenuItem {...props} key={"subItem" + data.name.replaceAll(" ", "") + index + subItem.name.replaceAll(" ", "")} nodeID={data.name.replaceAll(" ", "") + index + subItem.name.replaceAll(" ", "")} parentData={data} data={subItem} /> : "")}
    </div>;
}